module.exports = __webpack_public_path__ + "img/logo5.d30cdb12.png";